/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { MidasEffectError, SoftwareVersion } from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const getSoftwareVersions = createAction('[Software Version] Get Software Versions');
export const getSoftwareVersionSuccess = createAction(
  '[Software Version] Get Software Versions Success',
  props<{ versions: SoftwareVersion[] }>(),
);
export const getSoftwareVersionError = createAction(
  '[Software Version] Get Software Versions Error',
  props<MidasEffectError>(),
);

export const deleteVersion = createAction(
  '[Software Version] Delete Software Version',
  props<{ version: SoftwareVersion }>(),
);
export const deleteVersionSuccess = createAction(
  '[Software Version] Delete Software Version Success',
  props<{ deletedVersionId: number }>(),
);
export const deleteSoftwareVersionError = createAction(
  '[Software Version] Delete Software Version Error',
  props<MidasEffectError>(),
);
